import API_CONFIG from '../config/api.js';

const API_BASE_URL = API_CONFIG.BASE_URL;

const AUTH_STORAGE_KEY = 'rxapp_auth';

export const authService = {
  async needsSetup() {
    const response = await fetch(`${API_BASE_URL}/api/auth/needs-setup`);
    const data = await response.json();
    return data.needsSetup === true;
  },

  async setup(setupKey, email, password, confirmPassword) {
    const response = await fetch(`${API_BASE_URL}/api/auth/setup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ setupKey, email, password, confirmPassword })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Error en la configuración');
    }

    const authData = {
      token: data.token,
      user: data.user,
      roleLabel: data.roleLabel
    };
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
    localStorage.setItem('token', data.token);
    return authData;
  },

  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Error al iniciar sesión');
    }

    const authData = {
      token: data.token,
      user: data.user,
      roleLabel: data.roleLabel
    };
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
    localStorage.setItem('token', data.token);
    return authData;
  },

  async getMe() {
    const token = this.getToken();
    if (!token) return null;

    const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
      this.logout();
      return null;
    }

    const data = await response.json();
    const authData = {
      token,
      user: data.user,
      roleLabel: data.roleLabel
    };
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
    return authData;
  },

  getToken() {
    return localStorage.getItem('token');
  },

  getStoredAuth() {
    try {
      const stored = localStorage.getItem(AUTH_STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  },

  logout() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    localStorage.removeItem('token');
  }
};

export default authService;
